import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import PackagesData from '@/components/BuildingAnalytics/PackagesData/PackagesData'

import ReputationManagement from './ReputationManagement/ReputationManagement'
import Reviews from './Reviews/Reviews'
import OperationData from './OperationData/OperationData'
import MarketingData from './MarketingData/MarketingData'
import AppData from './AppData/AppData'
import BuildingData from './BuildingData/BuildingData'
import { getDatesInText } from './helpers'

const AnalyticsMainView = ({
  analyticsData,
  loading,
  startEndDates,
  reviewsData,
  loadingPackages,
  packagesAnalytics,
}) => {
  const { t } = useTranslation(['building-analytics'])
  const datesDescriptions = getDatesInText(startEndDates, t)
  const dataToShow = !loading && !analyticsData ? null : analyticsData

  return (
    <div className="ctp-building-analytics__container">
      <div className="ctp-building-analytics__container__main-block">
        <div className="ctp-building-analytics__container__main-block__upper-inline-blocks">
          <ReputationManagement
            loading={loading}
            datesDescriptions={datesDescriptions}
            reputationManagementData={dataToShow}
          />
          <Reviews
            datesDescriptions={datesDescriptions}
            loading={loading}
            reviewsData={!loading && !reviewsData ? null : reviewsData}
          />
        </div>
        <OperationData
          datesDescriptions={datesDescriptions}
          loading={loading}
          operationData={dataToShow}
        />
        <MarketingData
          datesDescriptions={datesDescriptions}
          loading={loading}
          marketingData={dataToShow}
        />
      </div>
      <div className="ctp-building-analytics__container__right-block">
        <AppData
          appDownloadsData={dataToShow}
          datesDescriptions={datesDescriptions}
          loading={loading}
        />
        <BuildingData loading={loading} buildingData={dataToShow} />
        <PackagesData loading={loadingPackages} packagesAnalytics={packagesAnalytics} />
      </div>
    </div>
  )
}

AnalyticsMainView.propTypes = {
  analyticsData: PropTypes.object,
  reviewsData: PropTypes.array,
  loading: PropTypes.bool,
  startEndDates: PropTypes.array,
  packagesAnalytics: PropTypes.object,
  loadingPackages: PropTypes.bool,
}
export default AnalyticsMainView
